module.exports = __webpack_public_path__ + "img/3.103c0884.jpg";